import tw from 'twin.macro';

export const StyledFooter = tw.footer`p-4 sm:p-6 max-w-[1200px] mx-auto text-gray-200 mb-0 text-center text-sm`;
